import { useEffect, useState } from "react";

import { handleHideChecksForUnderstanding } from "@/assignments/utils/assignmentActions";
import {
  AssignmentConfig,
  Assignment,
} from "@/types/models/Assignment.interface";
import { UserProperties } from "@/types/models/UserProperties.interface";
import { CONFIG_KEYS } from "@/view/AdditionalAssignmentSettings/AdditionalAssignmentSettings.constants";
import getAssignmentSetting from "@/view/utils/getAssignmentSetting";
import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";

const useChecksForUnderstandingVisibility = (
  userProperties: UserProperties,
) => {
  const [isChecksForUnderstandingVisible, setIsChecksForUnderstandingVisible] =
    useState(false);

  const { updatedAssignment: assignment, dispatch } =
    useAssignmentReducerContext() as {
      dispatch: () => void;
      updatedAssignment: Assignment;
    };

  const shouldChecksForUnderstandingBeVisible = () => {
    const { isStudent } = userProperties;
    const { assignment_config: assignmentConfig } = assignment || {};

    const isChecksForUnderstandingHidden = getAssignmentSetting(
      CONFIG_KEYS.hide_checks_for_understanding as keyof AssignmentConfig,
      assignment,
    );

    if (!isStudent && isChecksForUnderstandingHidden) {
      return false;
    }

    if (isStudent) {
      if (!assignment || !assignmentConfig || isChecksForUnderstandingHidden) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    setIsChecksForUnderstandingVisible(shouldChecksForUnderstandingBeVisible());
  }, [JSON.stringify(assignment), JSON.stringify(userProperties)]);

  const toggleChecksForUnderstanding = (isEnabled: boolean) => {
    handleHideChecksForUnderstanding(
      { hide_checks_for_understanding: !isEnabled },
      dispatch,
    );
    setIsChecksForUnderstandingVisible(isEnabled);
  };

  return { isChecksForUnderstandingVisible, toggleChecksForUnderstanding };
};

export default useChecksForUnderstandingVisibility;
